import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { cx } from '@mage-ui/styled-system/css';
import { detailSection } from '@mage-ui/styled-system/recipes';
import { useContext } from 'react';
import { GoToCta } from '../../navigation/ctas/GoToCta';
import { SectionHeadingTitle } from './section-headings/SectionHeadingTitle';

export const DetailSection = ({
  heading,
  children,
  anchor,
  sectionId,
  ...props
}) => {
  const { st } = useContext(StaticTextContext);
  return (
    <section
      className={cx(detailSection().root, 'group')}
      id={sectionId}
      {...props}
    >
      <div className={detailSection().wrapper}>
        <SectionHeadingTitle data={heading} />
        {children}
      </div>
      <div className={detailSection().goto}>
        <GoToCta text={anchor?.text || st('body.goto')} />
      </div>
    </section>
  );
};
